import { Box, BoxProps, Image } from '@cmpsr/components';

type ImageSectionAuthPagesProps = {
  src: string;
  alt: string;
  srcset?: string;
  sizes?: string;
  imageBoxProps?: BoxProps;
} & BoxProps;

export default function ImageSectionAuthPages({
  src,
  alt,
  srcset,
  sizes,
  imageBoxProps,
  ...props
}: ImageSectionAuthPagesProps) {
  return (
    <Box maxH="100%" overflow="hidden" {...props}>
      <Image src={src} alt={alt} srcSet={srcset} sizes={sizes} w="full" h="full" objectFit="cover" {...imageBoxProps} />
    </Box>
  );
}
